import React, { FC } from 'react';
import { Kfh_ArtirixSchoolItemType } from '../../types/graphqlTypes';
import { addHttp } from '../../utils/addHttp';
import Blade from '../Blade';
import { Spacer } from '../Spacer';
import { Typography } from '../Typography';

interface SchoolBladeProps {
  school: Kfh_ArtirixSchoolItemType;
}

interface ItemListItemProps {
  heading: string;
  value: string | number;
}
const ItemListItem: FC<ItemListItemProps> = ({ heading, value }) => {
  if (!value || !heading) {
    return null;
  }

  return (
    <li>
      <Typography variant="titleSmall">{heading}</Typography>
      <Typography variant="bodyLarge">{value}</Typography>
    </li>
  );
};
export const SchoolBlade: FC<SchoolBladeProps> = ({ school }) => {
  //

  if (!school) {
    return null;
  }

  const { name, schoolAddress, gender, minAge, maxAge, religiousCharacter, establishmentType, schoolUrl } = school;
  return (
    <Blade id="school">
      <Spacer>
        <Typography component="h2" variant="displaySmall">
          {name}
        </Typography>

        <Typography component="address" variant="bodyLarge">
          {schoolAddress.streetname}
          <br />
          {schoolAddress.town}
          <br />
          {schoolAddress.postcode}
        </Typography>

        <a href={addHttp(schoolUrl)} target="_blank" rel="noreferrer">
          {schoolUrl}
        </a>

        <Spacer as="ul" spacing="quarter">
          <ItemListItem heading="Type" value={establishmentType} />
          <ItemListItem heading="Religious Character" value={religiousCharacter} />
          <ItemListItem heading="Age range" value={`${minAge} to ${maxAge} years`} />
          <ItemListItem heading="Gender" value={gender} />
        </Spacer>
      </Spacer>
    </Blade>
  );
};
